import { render, staticRenderFns } from "./kunden-dubletten-filter.vue?vue&type=template&id=b5e394a0"
import script from "./kunden-dubletten-filter.vue?vue&type=script&lang=js"
export * from "./kunden-dubletten-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports